<template lang="pug">

    section.app-section(:class='{active: active}')

        .app-section__wrap(v-if="realInitiated")

            //- TYPES
            .app-section__group(v-for="group, gindex in groups", :key="gindex", :class="`app-section__group--${group.type}`")

                .app-section__group-wrap

                    app-block.app-section__block(v-for="block, bindex in group.content", :key="bindex", :class="`app-section__block--${block.type}`", :content="block", :base="base", :active="active")




</template>

<script>
/* eslint-disable no-console */
/* Components */
import AppBlock from './AppBlock.vue';
import {mapGetters} from 'vuex';

export default {
    name: 'app-section',

    props: {
        settings: {
            default: () => {
                return {};
            },
            type: Object
        },
        content: {
            default: () => {
                return {};
            },
            type: Object
        },
        index: {
            default: 0,
            type: Number
        },
        active: {
            default: false,
            type: Boolean
        },
        initiated: {
            default: false,
            type: Boolean
        }
    },

    components: {
        AppBlock
    },

    data() {
        return {
            visible: false,
            realInitiated: false
        };
    },

    computed: {
        ...mapGetters('core', ['isLiteMode']),
        base() {
            if (!this.settings) return '';
            return this.settings.base || '';
        },

        groups() {
            if (!this.content) return [];
            return this.content.groups || [];
        }
    },

    mounted() {
        this.init();
    },

    watch: {
        initiated(to) {
            if (to && !this.realInitiated) this.realInitiated = true;
        }
    },

    methods: {
        init() {
            if (this.initiated) this.realInitiated = true;
        }
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
//
.app-section {
    width: 100%;
    min-height: 3rem;
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        margin-bottom: 2rem;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &__group {
        padding: 0 0 1px;

        .app-section:last-child &:last-child {
            margin-bottom: 0;
        }

        &--group {
            &-outline {
                background-color: var(--color-outline-bg);
            }

            &-lite {
                background-color: var(--color-lite-bg);
            }

            &-lite,
            &-outline {
                padding-top: var(--width-column-grid);
                background-color: var(--color-outline-bg);
                margin-bottom: var(--width-column-grid);

                @media (--viewport-mobile), (--viewport-tablet-pt) {
                    padding-top: 2em;
                    margin-bottom: 2rem;
                }
            }
        }
    }

    &__group-wrap {
        max-width: var(--scr-max-width);
        padding: 0 var(--scr-padding-side);
        margin: 0 auto;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-left: 0;
            margin-right: 0;
            padding: 0;
        }
    }

    &__block {
        width: 100%;
    }
}
</style>
